import type { TFlowIcon } from '@forwardflow/features/campaign-flow/components/ui/FlowIcon'
import { TRailKey } from '@forwardflow/features/campaign-flow/interfaces/campaign-flow.types'

export interface IRailRow {
   key: TRailKey
   label: string
   icon: TFlowIcon
}

/** The three things we ask. */
export const ASKED_ROWS: IRailRow[] = [
   { key: 'who', label: 'Who to call', icon: 'users' },
   { key: 'handoff', label: 'Hot leads go to', icon: 'phone' },
   { key: 'voice', label: 'Voice', icon: 'voice' },
]

/** Already set up with our best defaults; open only to change. */
export const READY_ROWS: IRailRow[] = [
   { key: 'playbook', label: 'Playbook', icon: 'chat' },
   { key: 'numbers', label: 'Phone numbers', icon: 'pin' },
]
